import * as Types from '../../../__generated__/schema';

import { AlertSummaryFull } from '../fragments/AlertSummaryFull.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAlertStatusByIdVariables = Types.Exact<{
  input: Types.UpdateAlertStatusByIdInput;
}>;

export type UpdateAlertStatusById = { updateAlertStatusById: { alerts: Array<AlertSummaryFull> } };

export const UpdateAlertStatusByIdDocument = gql`
  mutation UpdateAlertStatusById($input: UpdateAlertStatusByIdInput!) {
    updateAlertStatusById(input: $input) {
      alerts {
        ...AlertSummaryFull
      }
    }
  }
  ${AlertSummaryFull}
`;
export type UpdateAlertStatusByIdMutationFn = Apollo.MutationFunction<
  UpdateAlertStatusById,
  UpdateAlertStatusByIdVariables
>;

/**
 * __useUpdateAlertStatusById__
 *
 * To run a mutation, you first call `useUpdateAlertStatusById` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlertStatusById` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlertStatusById, { data, loading, error }] = useUpdateAlertStatusById({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAlertStatusById(
  baseOptions?: Apollo.MutationHookOptions<UpdateAlertStatusById, UpdateAlertStatusByIdVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAlertStatusById, UpdateAlertStatusByIdVariables>(
    UpdateAlertStatusByIdDocument,
    options,
  );
}
export type UpdateAlertStatusByIdHookResult = ReturnType<typeof useUpdateAlertStatusById>;
export type UpdateAlertStatusByIdMutationResult = Apollo.MutationResult<UpdateAlertStatusById>;
export type UpdateAlertStatusByIdMutationOptions = Apollo.BaseMutationOptions<
  UpdateAlertStatusById,
  UpdateAlertStatusByIdVariables
>;
export function mockUpdateAlertStatusById({
  data,
  variables,
  errors,
}: {
  data: UpdateAlertStatusById;
  variables?: UpdateAlertStatusByIdVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: UpdateAlertStatusByIdDocument, variables },
    result: { data, errors },
  };
}
